// extracted by mini-css-extract-plugin
export default {"bundle-price":"bundle-price-0db7","highlight":"highlight-6ac9","sub":"sub-136a","small":"small-a4f0"};